import { render, staticRenderFns } from "./alertRelay.vue?vue&type=template&id=785d095e&"
import script from "./alertRelay.vue?vue&type=script&lang=js&"
export * from "./alertRelay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports